import styled from "styled-components";

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TooltipText = styled.span`
  visibility: hidden;
  width: 100%;
  background-color: white;
  border: 1px solid #f0f0f0;
  color: #666666 !important;
  font-size: 11px !important;
  line-height: 15px !important;
  font-weight: 400 !important;
  text-align: center;
  border-radius: 6px;
  padding: 10px 0;
  position: absolute;
  z-index: 100;
  top: 30px;
  left: 0;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
  margin: 0 auto;

  ${TooltipContainer}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;
